<template>
  <d-modal
    :key="'popup-auth-' + isVisible"
    :class="{ 'popupForm': true, 'is-hidden': !isVisible }"
    @close="onClosePopup"
    style="background-color: rgba(0,0,0,0.6)!important;">
    <d-modal-header>
      <d-modal-title>
        <h3 class="page-title">
          <template v-if="isEdit">Edycja upoważnienia</template>
          <template v-else>Dodaj upoważnienie</template>
        </h3>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <validation-observer ref="patients-form-auth" tag="form">
        <div class="form-group">
          <label for="name">
            Imię:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="text"
              :state="errors.length ? 'invalid' : null"
              v-model="data.name"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="last_name">
            Nazwisko:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="text"
              :state="errors.length ? 'invalid' : null"
              v-model="data.last_name"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="comments">
            Komentarz:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="text"
              :state="errors.length ? 'invalid' : null"
              v-model="data.comments"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="phone">
            Telefon:
          </label>
          <validation-provider
            :rules="'required'"
            v-slot="{ errors }">
            <d-input
              type="number"
              :state="errors.length ? 'invalid' : null"
              v-model="data.phone"
            />
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <validation-provider
            v-slot="{ errors }">
            <d-checkbox
              :state="errors.length ? 'invalid' : null"
              :checked="String"
              :value="'1'"
              :unchecked-value="'0'"
              v-model="data.health_benefits_inf"
            >
              Uzyskiwanie informacji o zdrowiu i świadczeniach
            </d-checkbox>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <validation-provider
            v-slot="{ errors }">
            <d-checkbox
              :state="errors.length ? 'invalid' : null"
              :checked="String"
              :value="'1'"
              :unchecked-value="'0'"
              v-model="data.medical_records"
            >
              Uzyskiwanie dokumentacji medycznej
            </d-checkbox>
            <div class="invalid-feedback">
              {{ errors[0] }}
            </div>
          </validation-provider>
        </div>
        <div class="form-group">
          <label for="scan_file">
            Skan dokumentu:
          </label>
          <file-input
            class="form-group"
            :onChange="setImage"
            :id="'scan_file'"
          />
        </div>
        <div class="popup-box-buttons">
          <d-button
            theme="success"
            class="text-nowrap"
            @click.prevent="validateForm">
            Potwierdź
          </d-button>
          <d-button
            theme="secondary"
            class="text-nowrap ml-3"
            @click.prevent="onClosePopup">
            Anuluj
          </d-button>
        </div>
      </validation-observer>
      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center overlay-loading"
        style="z-index: 1000;">
        Trwa ładowanie danych&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import FilterSelect from '@/components/others/FilterSelect';

export default {
  name: 'patients-form-auth-popup',
  components: { FilterSelect },
  props: {
    authorization: {
      default: null,
      type: Object
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    onClosePopup: {
      default: () => {},
      type: Function
    },
    onSubmitCallback: {
      default: () => {},
      type: Function
    },
    patientId: {
      required: true,
      type: Number
    }
  },
  computed: {
    isEdit () {
      return this.authorization && this.authorization.id;
    }
  },
  watch: {
    'isVisible': function (newValue) {
      if (newValue) {
        this.preparePopup();
      }
    }
  },
  data() {
    return {
      data: {
        id: '',
        comments: '',
        health_benefits_inf: '0',
        last_name: '',
        medical_records: '0',
        name: '',
        patient_id: '',
        phone: '',
        scan_file: {}
      },
      loaded: false
    };
  },
  mounted () {
  },
  methods: {
    preparePopup () {
      if (this.authorization && this.authorization.id) {
        Object.assign(this.data, this.authorization);
      } else {
        this.data.id = '';
        this.data.patient_id = this.patientId;
        this.data.name = '';
        this.data.last_name = '';
        this.data.phone = '';
        this.data.comments = '';
        this.data.scan_file = {};
        this.data.health_benefits_inf = '0';
        this.data.medical_records = '0';
      }

      Vue.nextTick(() => {
        if (this.$refs['patients-form-auth']) {
          this.$refs['patients-form-auth'].reset();
        }

        this.loaded = true;
      })
    },
    setImage(event) {
      this.data.scan_file = event.target.files[0];
    },
    validateForm () {
      FormUtils.validate(this.$refs['patients-form-auth'], this.submitForm);
    },
    submitForm  () {
      let imageFields = false;
      let formDataToSend = {
        id: this.data.id,
        patient_id: this.data.patient_id,
        name: this.data.name,
        last_name: this.data.last_name,
        phone: this.data.phone,
        comments: this.data.comments,
        health_benefits_inf: this.data.health_benefits_inf,
        medical_records: this.data.medical_records
      };
      if (this.data.scan_file) {
        formDataToSend.scan_file = this.data.scan_file;
        imageFields = ['scan_file'];
      }
      let endpointUrl = this.isEdit ? '/patients/auth/update/' + this.authorization.id : '/patients/auth/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano upoważnienie',
        successText: 'Wybrane upoważnienie zostało zapisane',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacje upoważnienia nie powiodły się. Spróbuj ponownie.',
        successAction: () => {
          this.onSubmitCallback(true);
          this.onClosePopup();
        }
      }, imageFields);
    }
  }
};
</script>

<style lang="scss">
  @import '../../../assets/scss/variables/mixins';
  .popup-box-buttons {
    @include popupButtons
  }
  .popupForm {
    &.is-hidden {
      display: none!important;
      pointer-events: none!important;
    }
    .modal-dialog {
      margin-top: 5rem;
    }
  }
</style>
